import React from 'react';
import { destinationFeaturesData, IconMap } from './data';

const DestinationSection: React.FC = () => {
    return (
        <section className="py-16 md:py-24 relative z-10">
            <div className="container mx-auto px-4 md:px-6">
                <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
                    <h2
                        className="text-3xl md:text-4xl lg:text-6xl font-serif font-black mb-4 md:mb-6 text-white leading-tight"
                    >
                        Why Choose <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400">BhriguGPT</span>?
                    </h2>
                    <p
                        className="text-base md:text-lg text-primary-200/80 font-sans leading-relaxed px-2 md:px-0"
                    >
                        From Vedic astrology to tarot readings, numerology to palm reading, experience comprehensive cosmic guidance in 10+ languages, all powered by advanced AI.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                    {destinationFeaturesData.map((feature, i) => {
                        const Icon = IconMap[feature.iconName];
                        return (
                            <div
                                key={i}
                                className="group relative p-6 md:p-8 rounded-[2rem] md:rounded-[2.5rem] bg-white/[0.08] border border-white/20 hover:bg-white/[0.12] hover:border-purple-400/50 transition-colors duration-300 flex flex-col items-center text-center"
                            >
                                <div className={`relative w-16 h-16 md:w-20 md:h-20 rounded-full ${feature.iconBg} flex items-center justify-center mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-500`}>
                                    <div className={`absolute -top-1 -right-1 w-3 h-3 md:w-4 md:h-4 rounded-full ${feature.dotColor} border-4 border-cosmic-900 shadow-lg`} />
                                    <div className="transform scale-[1.3] md:scale-[1.5]">
                                        {Icon && <Icon />}
                                    </div>
                                </div>
                                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4 text-white font-sans">{feature.title}</h3>
                                <p className="text-primary-200/60 text-sm font-sans leading-relaxed">
                                    {feature.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default DestinationSection;
